/** @format */

import { Navigate, Outlet } from "react-router-dom";

import Dashboard from "./Dashboard";
import MyAccount from "./MyAccount";
import UserResourcePage from "./UserResourcePage";
import UserResourceIndex from "./UserResourceIndex";
import AuthFlag from "../auth/AuthFlag";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import { getUserToken } from "../auth/authSlice";
import { Spinner } from "react-bootstrap";

const Unauthorised = () => {
  const { t: _ } = useTranslation();
  const userToken = useAppSelector(getUserToken);

  // NOTE: if the user is logged in, assume that the page is just loading. Otherwise, redirect to index
  return !userToken ? (
    <Navigate to="/" />
  ) : (
    <>
      <div className="position-absolute top-50 start-50 translate-middle">
        <Spinner />
      </div>
      <Link to={"/"}>{_("Back")}</Link>
    </>
  );
};

const userRoutes = [
  {
    index: true,
    element: <Navigate to="/" />,
  },
  {
    path: "account",
    element: <MyAccount />,
  },
  {
    path: "*",
    element: (
      <AuthFlag
        authGroup={["wjec", "teacher", "admin"]}
        fallback={<Unauthorised />}
      >
        <Outlet />
      </AuthFlag>
    ),
    children: [
      {
        path: "account",
        element: <MyAccount />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
        children: [
          { index: true, element: <UserResourceIndex /> },
          {
            path: "r/:userResource/:copy/",
            element: <UserResourcePage />,
          },
        ],
      },
    ],
  },
];

export default userRoutes;
